{
  "sidebar": {
    "description": "Here you can reserve access for yourself. Access covers one person.",
    "ownAccessNone": "Your gym access rights: You currently have no valid gym access rights.",
    "ownAccessWithCount_one": "Your gym access rights: You have one valid gym access right.",
    "ownAccessWithCount_other": "Your gym access rights: You have {{count}} valid gym access rights.",
    "ownAccessLoading": "Your gym access rights: loading..."
  },
  "modal": {
    "title": "Reserve",
    "releaseTitle": "Release",
    "headerReserve": "Gym access",
    "headerRelease": "Gym access",
    "gymRulesLink": "Rules",
    "gymAccessTermsLink": "Reservation terms",
    "acceptRules": "I accept the rules and access reservation terms",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "priceLabel": "Price",
    "perMonth": "€ / month"
  },
  "reservation": {
    "title": "Gym",
    "availabilitySentence": "There are currently",
    "availabilitySentenceBold": "{{count}} passes available at the gym.",
    "today": "Today",
    "priceLabel": "Price",
    "priceAtStart": "Price at contract start {{price}} € / month.",
    "buttonReserve": "Reserve",
    "buttonRelease": "Release access",
    "releaseAccessEnding": "This access has already been terminated and cannot be changed.",
    "releaseAccessFuture": "Future reservations can be cancelled via customer service.",
    "releaseAccessUnavailable": "Only the contract party or payer can release access.",
    "currentAccessTitle": "Current reservations",
    "validUntil": "Valid {{startDate}} - {{endDate}}.",
    "validFrom": "Valid from {{startDate}}, until further notice.",
    "endsOnLabel": "Ends {{endDate}}",
    "activeLabel": "Active",
    "reachedLimitInfo": "You have reached the maximum number of active reservations ({{max}}) and cannot make any more.",
    "accessSummary": {
      "none": "You do not currently have a valid gym access right.",
      "active_one": "You have one valid gym access right.",
      "active_other": "You have {{count}} valid gym access rights.",
      "terminating": "You have terminated your gym access. Your access remains valid until {{endDate}}."
    }
  },
  "reservationModal": {
    "reservationStartsLabel": "Reservation takes effect",
    "successTitle": "Access reserved!",
    "successMessage": "Gym access has now been reserved!",
    "accessStartsLabel": "Access starts:",
    "priceLabel": "Price:",
    "perMonth": "€ / month",
    "acceptRules": "I accept {{address}} rules and gym access reservation terms",
    "contractNotStartedError": "The reservation cannot start before the contract start date."
  },
  "releaseModal": {
    "successTitle": "Access removed!",
    "successMessage": "Gym access has now been removed!",
    "confirmQuestion": "Are you sure you want to release the access?",
    "accessDetails": "Access: {{address}}, valid from {{startDate}}.",
    "validUntilImmediate": "If you terminate your access now, it ends immediately.",
    "validUntilPrefix": "If you terminate your access now, it will be valid until",
    "validUntilSuffix": "."
  },
  "noCalendarsAvailable": "No reservation calendars available",
  "timeFormatting": {
    "startingFrom": "starting from",
    "priceAddedToContract": "will be added to your contract"
  }
}
